import Icon from '@loggi/ui/components/icon';
import colors from '@loggi/ui/components/utils/colors';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './custom-radio.styles.scss';

const CustomRadio = ({
  value,
  label,
  isSelected,
  onChange,
  id,
  icon,
  iconColor
}) => {
  return (
    <div key={value} className={styles.customRadio}>
      <input
        id={id}
        type="radio"
        value={value}
        checked={isSelected}
        onChange={onChange}
      />
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <label htmlFor={value} className={icon ? 'hasIcon' : ''}>
        {icon && <Icon type={icon} color={iconColor} />}
        {label}
      </label>
    </div>
  );
};

CustomRadio.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconColor: PropTypes.string
};

CustomRadio.defaultProps = {
  iconColor: colors.type.STORM_500,
  icon: null,
  isSelected: false
};

export default CustomRadio;
